// extracted by mini-css-extract-plugin
export var container = "_bc-0";